<div class="item" *ngIf="isLoading == true">
  <i [ngClass]="{'loader': true, '--4': variant == '--4', '--5': variant == '--5'}"
    [ngStyle]="{'background-color': color}"></i>
</div>

<div *ngIf="showProgress && progress > 0" class="progress-box">
  <span>{{ progress + ' %' }}</span>
</div>